import { render, staticRenderFns } from "./legend-with-title.vue?vue&type=template&id=4acf9503"
import script from "./legend-with-title.vue?vue&type=script&lang=js"
export * from "./legend-with-title.vue?vue&type=script&lang=js"
import style0 from "./legend-with-title.vue?vue&type=style&index=0&id=4acf9503&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports